// Single source of truth for contact info
export const BRAND = "A2 Experts";
export const PHONE_RAW = "+918368280438"; // E.164 format
export const PHONE_DISPLAY = "+91 83682 80438";
export const WHATSAPP_RAW = "918368280438";
export const WHATSAPP_MSG = encodeURIComponent(
  "Hi A2 Experts, I am looking for washing machine repair service in Delhi & Noida"
);
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_RAW}?text=${WHATSAPP_MSG}`;
export const TEL_LINK = `tel:${PHONE_RAW}`;

// Fires Google Ads "Lead" conversion. Safe to call from any click handler;
// does NOT intercept navigation (the href/target on the link continues to work).
export const trackLeadConversion = () => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag_report_conversion === "function") {
      window.gtag_report_conversion();
    }
  } catch (e) {
    // swallow — never block the user from calling/WhatsApping
  }
};
